import { Sel } from 'uix/registries';
import { windowDevicePixelRatio, getBestWebcacheFit } from 'uix/utils';
import { useSelector } from './';
export const useWebcacheWidth = (targetWidth, orgWidth)=>{
    let { sizes } = useSelector(Sel.iconfig).webcache;
    targetWidth = targetWidth * windowDevicePixelRatio;
    return getBestWebcacheFit(targetWidth, sizes, orgWidth);
};
export const useBestWebcacheFit = ()=>{
    let { sizes } = useSelector(Sel.iconfig).webcache;
    return (targetWidth, orgWidth)=>getBestWebcacheFit(targetWidth * windowDevicePixelRatio, sizes, orgWidth);
};
